import { MenubarLarge_ } from '../../../areas/Menubar/MenubarLarge_';
export class LargeComponents {
    MenubarLarge_ = MenubarLarge_;
}
